<template>
  <div class="container section transparent">
    <div class="row">
      <div class="mdl-card mdl-cell--4-col">
        <div class="mdl-card__supporting-text">
          <div
            class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder"
          >
            <input
              class="mdl-textfield__input"
              type="text"
              id="user-name"
              :value="user.name"
              v-on:input="updateName"
            />
            <label class="mdl-textfield__label" for="user-name">{{
              t("Name")
            }}</label>
          </div>
        </div>
      </div>
      <!--<div class="mdl-card mdl-cell--4-col">
        <div class="mdl-card__supporting-text">
          <div
            class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label has-placeholder"
          >
            Card details
            <label class="mdl-textfield__label" for="user-name">{{
              t("Payment Method")
            }}</label>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import Helpers from "@/mixins/Helpers";
import { mapState } from "vuex";

export default {
  mixins: [Helpers],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      user: state => state.user.data,
      ref: state => state.user.ref,
      service: state => state.user.service
    })
  },
  methods: {
    updateName: function(event) {
      this.ref.update({
        name: $(event.target).val()
      });
    },
    updatePrinity: function(event) {
      this.ref.update({
        managed: $(event.target).is(":checked")
      });
    }
  }
};
</script>
<style lang="scss">
.panel-heading {
  font-size: 1.385rem;
  font-weight: 400;
  color: #3d3d3d;
  padding: 24px 0 14px;
  // margin: 0 20px;
}
.panel-body {
  padding: 14px 20px;
}
.mdl-card {
  min-height: 0px !important;
  margin: 15px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Settings.vue